<div class="row flex-nowrap m-0 c-t-55px position-fixed w-100 c-h-100-55px">
	<ng-content select="[leftSideBar]"></ng-content>
	<div class="col h-100 p-0 d-flex flex-column flex-nowrap c-content-min-width" [class.overflow-auto]="scrollbar">
		<ng-content></ng-content>
	</div>
	<ng-content select="[rightSideBar]"></ng-content>
</div>
